import _ from 'lodash';
import { useEffect, useState } from 'react';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { BatchListItem } from '@scale/shared/types/corp/batch/batchListItem';
import { TaskBatchStatus } from '@scale/shared/defaults';

interface IFetchBatches {
  batches: BatchListItem[];
  error: any;
  isLoading: boolean;
}

interface IFetchBatchesQuery {
  project: string;
  status: TaskBatchStatus & 'all';
  from: Date;
  to: Date;
  customerId: string;
  customQuery: Record<string, any>;
}

const useFetchBatches = (query: IFetchBatchesQuery): IFetchBatches => {
  const [batches, setBatches] = useState<BatchListItem[]>([]);
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await apiFetch(null, 'corp-api/batch-actions/list', { query });
        setBatches(response);
        setIsLoading(false);
        setError(false);
      } catch (e) {
        setError(e);
        setIsLoading(false);
      }
    };

    if (!_.isEmpty(query)) {
      fetchData();
    }
  }, [query]);
  return { batches, error, isLoading };
};

export default useFetchBatches;
